<div class="popup" *ngIf="isVisibleDetails">
  <div class="panelDetailGeofences" [ngClass]="{'expandir': fullScreen}">
    <div class="mobile-handle" *ngIf="!mobileQuery.matches" (click)="fullScreen = !fullScreen">
      <mat-icon class="handle-arrow">{{ fullScreen ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
    </div>

    <loading [isLoading]="isLoading"></loading>

    <div class="details-flex">

      <!-- Primera sección - Header -->
      <div class="header_panel">

        <!-- Encabezado con icono -->
        <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
          <img src="/assets/img/icon_geofence_on.png" class="header-img" />
        </div>

        <!-- Título y controles -->
        <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
          <label class="geofence-title-container">
            
            <div class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
              <mat-icon>arrow_back_ios</mat-icon>
            </div>

            <div class="vin-title">
              {{ this.Title }}
            </div>

            <div class="tool-opener" (click)="toggleToolButton()" id="geofenceToolOpener">
              <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
              <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
            </div>
          </label>
          
          <!-- <label *ngIf="!mobileQuery.matches" class="header-text-label">Guid</label>
          <label class="subtitlePanel">{{this.Guid}}</label> -->
        </div>

        <!-- Sección de herramientas -->
        <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical details-tool-list-for-tutorial" id="panelDetailGeofencesTool">
          <location-button-toolbar 
            [isGeofenceDetails]="true" 
            [geofenceGuid]="this.Guid"
            [isVerticalList]="true">
          </location-button-toolbar>

          <app-report-list 
            [showReportes]="false" 
            [editGeofences]="true" 
            [isGeofenceDetails]="true" 
            [geofenceGuid]="this.Guid"
            [isVerticalList]="true">
          </app-report-list>
        </div>

      </div>
        
      <div class="geofences-data-scroll-container" id="panelDetailGeofencesData">
        
        <div class="card-container">
          <div class="data-section-container">
            <div class="text-header">
              <h3>Detalle de Geocerca</h3>
            </div>

            <ng-container *ngFor="let key of Keys">
              <div *ngIf="!key.startsWith('_') && !(key == 'Radio' || key == 'Identifiers' || key == 'Nombre' || key == 'Guid')" class="row-data">
              
                <div class="">
                  <label class="titlePanel">{{ key }}</label>
                </div>

                <div class="general-data-container">
                  <div class="general-data">{{ Values[Keys.indexOf(key)] }}</div>
                </div>

              </div>
            </ng-container>

          </div>
          
          <!-- Tercera sección -->
          <div class="data-section-container">
            <div class="text-header">
              <h3>Identificadores ({{ identifiers.length }})</h3>
            </div>
          
            <div *ngFor="let identifier of identifiers">
              <div *ngIf="identifier != ''" class="row-data">
                <div class="">
                  <label class="titlePanel">{{ identifier }}</label>
                </div>
              </div>
            </div>

            <div *ngIf="identifiers.length == 0" class="row-data">
              <div class="">
                <label class="titlePanel"> Sin registros </label>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>  

    <div class="">
      <div class="section-footer-background">
      </div>
    </div>
  </div>
</div>